<script>
import appConfig from '@src/app.config'
import NavBar from '@components/nav-bar.vue'
import Footer from '@components/footer.vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  metaInfo: {
    meta: [
      window.innerWidth > 767 && window.innerWidth < 1022
        ? {
            name: 'viewport',
            content: 'width=1022,maximum-scale=1,user-scalable=no',
          }
        : {},
    ],
  },
  components: { NavBar, Loading, Footer },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      console.log(title)
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title}` : appConfig.title
    },
  },
  data() {
    return {
      innerHeight: 0,
      initialHeight: 0,
    }
  },
  computed: {
    includes() {
      return this.$store.state.layout.keepAliveIncludes
    },
    couponPage(){
      if(this.$route.path && this.$route.path.indexOf('coupon-list') > 0){
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.$refs.loading.$el.removeAttribute('tabindex')
  },
  destroyed() {
    window.onresize = null
  },
  methods: {
    focusIn() {
      if (
        /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) &&
        this.$store.state.layout.focusHideEnable
      ) {
      }
    },
    focusOut() {
      if (
        /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) &&
        this.$store.state.layout.focusHideEnable
      ) {
      }
    },
  },
}
</script>
<template>
  <div id="app" @focusin="focusIn" @focusout="focusOut">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <!-- <RouterView v-if="!$route.meta.keepAlive" :key="$route.fullPath" /> -->
    <NavBar v-if="!couponPage"/>
    <keep-alive :include="includes">
      <RouterView :key="$route.name" />
    </keep-alive>
    <Loading
      ref="loading"
      :active="$store.state.layout.isLoading"
      color="#070141"
      loader="bars"
      :opacity="0.9"
      :can-cancel="true"
    ></Loading>
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
// @import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
// @import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
// @import '@design';

*,
*::before,
*::after {
  // box-sizing: border-box;
}

* {
  -webkit-overflow-scrolling: touch;
}

#app {
  height: 100%;
  word-break: break-all;
}

@media screen and (min-width: 768px) {
  #app {
    min-height: 500px;
  }
}

// ===
// Base element styles
// ===
fieldset,
img {
  vertical-align: bottom;
  pointer-events: none;
  touch-action: none;
  -webkit-user-select: none;
  user-select: none;
  border: 0;
  -webkit-touch-callout: none;
}
</style>
